export { default } from './AccountSettings';

export const ValidTabsDeprecated = ['professional_info', 'tourbook_contact_info'] as const;
export type AccountSettingsTabDeprecated = (typeof ValidTabsDeprecated)[number];

export const ValidTabs = ['profile', 'inquiry', 'email_notifications'] as const;
export type AccountSettingsTab = (typeof ValidTabs)[number];
